import { defaultAgent, apiResponse } from "../helpers/web-agent";
import { toastError, toastSuccess } from "./toast";
import { tokenExpired } from "./auth";
import {
  GET_DISTANCE_LIST,
  GET_DISTANCE_LIST_REQUEST,
  GET_DISTANCE_MATRIX,
  GET_DISTANCE_MATRIX_REQUEST,
} from "../constants/action-types";

export const getFieldDistanceListRequest = () => ({
  type: GET_DISTANCE_LIST_REQUEST,
});
export const getFieldDistanceList = (payload, farmId) => ({
  type: GET_DISTANCE_LIST,
  payload,
  farmId,
});
export const getGeneratedDistanceListRequest = () => ({
  type: GET_DISTANCE_MATRIX_REQUEST,
});
export const getGeneratedDistanceList = (payload, farmId) => ({
  type: GET_DISTANCE_MATRIX,
  payload,
});

export const saveDistance = (data) => (dispatch) => {
  defaultAgent
    .post("/api/distance/save", data)
    .then((res) => {
      const agentResult = apiResponse(res, {});
      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.data) {
        dispatch(toastSuccess(agentResult.message));
      } else if (agentResult.message) {
        if (agentResult.status === "error") {
          dispatch(toastError(agentResult.message));
        } else {
          dispatch(toastSuccess(agentResult.message));
        }
      }
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};

export const getDistanceList = (farmId) => (dispatch) => {
  dispatch(getFieldDistanceListRequest());
  defaultAgent
    .get("/api/distance/list", { farm_uuid: farmId })
    .then((res) => {
      const agentResult = apiResponse(res, []);
      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.message) {
        dispatch(getFieldDistanceList([], farmId));
        dispatch(toastError(agentResult.message));
      } else if (agentResult.data)
        dispatch(getFieldDistanceList(agentResult.data, farmId));
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};

export const getGeneratedDistanceLists = (params) => (dispatch) => {
  dispatch(getGeneratedDistanceListRequest());

  const reqParams = {
    farm_uuid: params.farmId,
    distance: params.distance,
  };

  defaultAgent
    .post("/api/distance/multiple/matrix", reqParams)
    .then((res) => {
      const agentResult = apiResponse(res, []);

      if (agentResult.isUnauthorized) {
        dispatch(toastError(agentResult.message));
        dispatch(tokenExpired());
      } else if (agentResult.message) {
        dispatch(getGeneratedDistanceList([]));
        dispatch(toastError(agentResult.message));
      } else if (agentResult.data) {
        dispatch(getGeneratedDistanceList(agentResult.data));
      }
    })
    .catch((ex) => {
      dispatch(toastError(ex.message));
    });
};
